import React, {
  Component,
  useCallback,
  useState,
  createRef,
  useEffect
} from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  height: 100%;
`;

const SectionsWrapper = styled.div`
  height: 100%;
  display: flex;
`;

const Grouping = styled.div`
  cursor: pointer;
  font-weight: ${(props) => (props.selected ? 'bold' : '500')};
  padding: 8px;
  padding-left: 20px;
  color: ${(props) => (props.selected ? '#000000' : 'rgba(0, 0, 0, 0.5)')};
`;

function ScrollViewLayout(props) {
  const { sections } = props;
  const [focusedSection, setFocusedSection] = useState(sections[0].name);
  const [refMap] = useState(
    (function() {
      const _refMap = {};
      for (let i = 0; i < sections.length; i++) {
        _refMap[sections[i].name] = createRef();
      }
      return _refMap;
    })()
  );
  const scrollIntoView = (section) => {
    refMap[section].current.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
    // setFocusedSection(section);
  };

  const getDimensions = (ele) => {
    const { height } = ele.getBoundingClientRect();
    const { offsetTop } = ele;
    const offsetBottom = offsetTop + height;

    return {
      height,
      offsetTop,
      offsetBottom
    };
  };

  useEffect(() => {
    const handleScroll = () => {
      let selected = null;
      Object.keys(refMap).forEach((prop) => {
        const ele = refMap[prop].current;
        const { height: wrapperHeight } = getDimensions(ele.parentNode);
        const scrollPosition = ele.parentNode.scrollTop + wrapperHeight;
        if (ele) {
          const { offsetBottom, offsetTop } = getDimensions(ele);
          const keys = Object.keys(refMap);
          if (ele.parentNode.scrollTop === 0) {
            selected = keys[0];
          } else if (ele.parentNode.scrollHeight === scrollPosition) {
            selected = keys[keys.length - 1];
          } else if (
            scrollPosition > offsetTop &&
            scrollPosition < offsetBottom
          ) {
            selected = prop;
            return false;
          }
        }
      });
      if (selected && selected !== focusedSection) {
        setFocusedSection(selected);
      }
    };
    window.addEventListener('scroll', handleScroll, true);
    return () => {
      window.removeEventListener('scroll', handleScroll, true);
    };
  }, [focusedSection]);
  const wrapperRef = createRef();
  return (
    <Wrapper className="ScrollViewWrapper">
      {props.header ? <div>{props.header}</div> : ''}
      <SectionsWrapper>
        <div ref={wrapperRef} className="scroll-section">
          {props.sections
            ? props.sections.map((section) => {
                return (
                  <div className="mb10" ref={refMap[section.name]}>
                    {section.component}
                  </div>
                );
              })
            : ''}
        </div>
        <div>
          {props.sections
            ? props.sections.map((section) => {
                return (
                  <Grouping
                    selected={focusedSection === section.name}
                    onClick={scrollIntoView.bind(this, section.name)}
                  >
                    {section.title}
                  </Grouping>
                );
              })
            : ''}
        </div>
      </SectionsWrapper>
    </Wrapper>
  );
}

export default ScrollViewLayout;
